import { BankAccount, PaymentLink, Wedding } from "../../types/wedding";
import { generateAPI } from "../api.generator";

export const updateBankAccountsAndPaymentLinks = generateAPI<
  {
    body: {
      bankAccounts: BankAccount[];
      paymentLinks: PaymentLink[];
    };
  },
  Wedding
>("put", "wedding/bank-accounts-and-payment-links", "wedding/");
